
import { Tenant } from 'shared/types';

import { AvailableTenant } from '../../types';
import TenantOption from './TenantOption';
import TenantOptionReadonly from './TenantOptionReadonly';

interface TenantsListProps {
    availableTenants: AvailableTenant[];
    onTenantChange: (tenant: AvailableTenant) => void;
    selectedTenant: Tenant;
}

export default function TenantsList({ availableTenants, onTenantChange, selectedTenant }: TenantsListProps) {
    const filteredTenants = availableTenants.filter(tenant => tenant.roles.includes('Candidate') && tenant.id !== selectedTenant.internalName);
    const currentTenant = availableTenants.find(tenant => tenant.id === selectedTenant.internalName);

    return (
        <>
            { currentTenant && <TenantOptionReadonly tenant={ currentTenant }
                bold={ filteredTenants.length > 0 } /> }
            { filteredTenants.map(tenant => (
                <TenantOption key={ tenant.id }
                    onTenantChange={ onTenantChange }
                    tenant={ tenant } />
            )) }
        </>
    );
}
